import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { rootKeys } from '../../cache-keys/rootKeys';
import { userKeys } from '../../cache-keys/userKeys';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { assignment_api } from '@axo/shared/data-access/api';
import { assignmentKeys } from '../../cache-keys/assignmentKeys';
import { applicationAssignmentKeys } from '../../cache-keys/applicationAssignmentKeys';

export function useSetProcessed() {
  const {
    state: {
      user: { clientID },
    },
  } = useContext(DataAccessContext);
  const client = useQueryClient();
  const api = useAPI();

  return useMutation(assignment_api.setAssignmentProcessed(api), {
    onSuccess: (assignment, loanApplicationID) => {
      client.invalidateQueries(
        applicationAssignmentKeys.root({
          applicationID: loanApplicationID,
          marketCountry: assignment.Country,
        })
      );
      client.invalidateQueries(rootKeys.searchIndex());
      client.invalidateQueries(
        assignmentKeys.root({
          marketCountry: assignment.Country,
        })
      );
      client.invalidateQueries(
        userKeys.assignedApplications({
          user: clientID,
          country: assignment.Country,
        })
      );
    },
  });
}
